export default __webpack_public_path__ + "static/media/logo-white.926c1c79.png";